import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isNilOrEmpty } from 'helpers';

import { CampaignContextState, StateName } from './campaign-context-state';

export const selectCampaignContext = createFeatureSelector<CampaignContextState>(StateName);

export const selectCurrentCampaign = createSelector(selectCampaignContext,
  (state) => state.current_campaign);

export const selectCampaignHasEntityConnections = createSelector(selectCurrentCampaign,
  (state) => !isNilOrEmpty(state?.entityConnectionTypes)
);
